import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isAsyncValidating, isDirty, isSubmitting, submit } from 'redux-form';
import { propShape, propStr } from '../../../../helpers/custom-prop-types';
import SubmitButton from '../../Button/SubmitButton';
const FormConsultantProfileSticky = (props) => {
    const { formName, previewUrl, setOnSubmitCompleteCallbackRef, setOnSubmitStartCallbackRef, } = props;
    const [onDoingPreview, changeOnDoingPreview] = useState(false);
    const [onDoingSubmit, changeOnDoingSubmit] = useState(false);
    const dispatch = useDispatch();
    const { asyncValidating, dirty, submitting } = useSelector((state) => ({
        asyncValidating: isAsyncValidating(formName)(state),
        dirty: isDirty(formName)(state),
        submitting: isSubmitting(formName)(state),
    }));
    const onClick = useCallback((e) => {
        const { is_preview: rawIsPreview } = e.currentTarget.dataset;
        const isPreview = rawIsPreview === '1';
        setOnSubmitStartCallbackRef.current = () => {
            if (isPreview) {
                changeOnDoingPreview(true);
            }
            else {
                changeOnDoingSubmit(true);
            }
        };
        setOnSubmitCompleteCallbackRef.current = (result) => {
            changeOnDoingPreview(false);
            changeOnDoingSubmit(false);
            if (result && isPreview) {
                window.open(previewUrl, '_blank');
            }
        };
        if (isPreview && !dirty) {
            // 変更がなければ何もしない
            window.open(previewUrl, '_blank');
            return;
        }
        dispatch(submit(formName));
    }, [
        dispatch,
        dirty,
        previewUrl,
        formName,
        setOnSubmitCompleteCallbackRef,
        setOnSubmitStartCallbackRef,
    ]);
    return (_jsx("div", Object.assign({ className: 'sticky-footer' }, { children: _jsxs("div", Object.assign({ className: 'footer-action' }, { children: [_jsx(SubmitButton, { buttonType: 'button', className: 'link-text', "data-is_preview": 1, isDisabled: asyncValidating || submitting, isLoading: onDoingPreview, onControlClick: onClick, tabIndex: 0, text: 'プレビュー' }), _jsx(SubmitButton, { buttonType: 'button', className: 'btn btn-new-primary centered medium btn-save-i is-full', "data-is_preview": 0, isDisabled: asyncValidating || submitting, isLoading: onDoingSubmit, onControlClick: onClick, tabIndex: 0, text: _jsxs(_Fragment, { children: [_jsx("i", Object.assign({ className: 'material-icons md-14' }, { children: "save_alt" })), "\u4FDD\u5B58\u3059\u308B"] }) })] })) })));
};
FormConsultantProfileSticky.propTypes = {
    formName: propStr().isRequired,
    previewUrl: propStr().isRequired,
    setOnSubmitCompleteCallbackRef: propShape().isRequired,
    setOnSubmitStartCallbackRef: propShape().isRequired,
};
export default FormConsultantProfileSticky;
